var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.$t("domain_authority"))+"\n  ")]),_vm._v(" "),_c('div',[_c('highcharts',{ref:"highchart",attrs:{"options":_vm.chartOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }